<template>
  <div class="allBox" v-loading.fullscreen="loading">
    <div class="allBoxTitle">
      <h3 class="allTitle">热门产品</h3>
      <router-link :to="{path:'/market'}">查看更多</router-link>
    </div>
    <div class="ball" ref="ball"></div>
    <ul class="hot products" v-if="list!=null">
      <li v-for='(item,index) in list' :key='index' :class="[item.Status==2&&item.Presale!=1?'outStock':'',item.Status!=2&&item.QuantitySold<=0&&item.Presale!=1?'sold':'',item.Presale==1?'presale':'']">
        <i v-if="item.Status==2"></i>
            <i v-if="item.Presale==1"></i>
        <div class="outOfStock" v-if="item.QuantitySold<=0">缺货</div>
        <el-button v-if="(userInfo!=null&&item.QuantitySold>0)&&item.Presale!=1" type="primary" class="addCart" @click="toCart($event,item)">加入购物车</el-button>
        <router-link :to="{path:'/market/item/'+item._id+'?type=1'}">
          <div class="imgBox">
            <img :src="item.TitImg+'?imageView2/2/w/238'">
          </div>
          <div class="line_txt3 productsText">{{item.Title}}
          </div>
          <div class="productsPrice">{{item.Price.toLocaleString()}}</div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: 'hotproducts',
  data() {
    return {
      loading: false,
      userInfo: getInfo(),
      list: null,
      iscart: false,
    }
  },
  mounted() {
    this.$root.$on("isLogin", val => {
      this.userInfo = getInfo()
    })
  },
  created() {
    this.getHotCommodityList();
  },
  methods: {
    getHotCommodityList() {
      let that = this
      that.loading = true;
      that.$get(that.$interface.GetHotCommodityPageList, '').then(res => {
        if (res.Result != 0) {
          that.list = res.Data
        }
        that.loading = false;
      }).catch(err=>{
        that.loading = false;
      })
    },
    // getCommodityList() {
    //   let that = this
    //   let data = { PageIndex: 1, PageSize: 8 }
    //   that.$get(that.$interface.GetCommodityPageList, data).then(res => {
    //     if (res.Result != 0) {
    //       that.list = res.Data
    //     }
    //   })
    // },
    toCart(e, obj) {
      let that = this;
      let data = { commodityId: obj._id, num: 1, memberId: that.userInfo._id,type:true}
      that.$post(that.$interface.AddMyCart, data).then(res => {
        if (res.Result != 0) {
          // that.$refs.ball.style.top = e.pageY + 'px';
          // that.$refs.ball.style.left = e.pageX + 'px';
          // setTimeout(function() {
          //   that.$refs.ball.className = 'ball ball_hover'
          // }, 200)
          // setTimeout(function() {
          //   that.$refs.ball.className = 'ball'
          // }, 500)
          that.$root.$emit("newCart", "true");
          
          this.toCartBox(obj)
        }else{
          that.$message.error(res.Msg);
        }
      })
    },

    toCartBox(obj){
      let that=this
      let title='商品已成功加入购物车！';
      let html='<div style="display: flex;">'
      +'<img style="width: 120px;height: 120px;object-fit: contain;border: 1px solid #F0F0F0;border-radius: 8px;margin-right: 10px;" src='+obj.TitImg+' />'
      +'<div style="width: 65%;">'+obj.Title+'<span style="display: block;">数量：1</span></div>'
      +'</div>'
      this.$confirm(html, title, {
          dangerouslyUseHTMLString: true,
          showCancelButton:false,
          lockScroll:false,
          confirmButtonText:'去购物车结算'
        }).then(() => {
            
      that.$root.$emit("newCart", "true");
      that.$router.push({ path: '/cart' })
          });
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/home.css";

</style>



// WEBPACK FOOTER //
// src/pages/home/hotproducts.vue